import React from "react";

/* eslint @typescript-eslint/no-explicit-any: ["off"] */
interface HighlightedSectionHeadingProps {
    heading: string;
    icon?: any;
}

const HighlightedSectionHeading: React.FC<HighlightedSectionHeadingProps> = ({ heading, icon }) => {
    const words = heading.split(" ");
    const lastWord = words[words.length - 1];
    const leadingWords = words.slice(0, -1).join(" ");

    return (
        <div className="section-heading">
            { icon && <div className="icon-div">{icon}</div> }
            <span className="label">
                {leadingWords ? `${leadingWords} ` : ""}
                <span className="label-highlight">{lastWord}</span>
            </span>
        </div>
    );
};

export default HighlightedSectionHeading;
